<template>
  <div class="box is-shadowless">
    <b-field >
      <b-input v-model="route" placeholder="ROUTE" />
      <p class="control">
        <b-button label="LOAD" type="is-dark" @click="load" />
      </p>
    </b-field>

    <guide-slider :guide="route" ref="guideSlider" />
  </div>
</template>

<script>
import GuideSlider from "@/components/Guide/GuideSlider";

export default {
  components: {
    GuideSlider,
  },
  data: () => ({
    route: "",
  }),
  methods: {
    load() {
      this.$refs.guideSlider.fetchSteps();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Guide/index.vue